"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.persistRefreshToken = exports.persistAccessToken = exports.getRefreshToken = exports.getAccessToken = exports.fetchRefreshedRefreshToken = exports.fetchRefreshTokenEmailPass = exports.fetchAccessToken = exports.clearTokens = exports.REFRESH_TOKEN = exports.ACCESS_TOKEN = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _jsTools = require("@airportlabs/js-tools");
var core = _interopRequireWildcard(require("./core"));
var fetchers = _interopRequireWildcard(require("./fetchers"));
var _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ACCESS_TOKEN = exports.ACCESS_TOKEN = "ACCESS_TOKEN";
var REFRESH_TOKEN = exports.REFRESH_TOKEN = "REFRESH_TOKEN";

/**
 * Returns the stored REFRESH_TOKEN from local storage.
 *
 * @returns {(string|undefined)} Returns the token string or undefined if no
 * token or an expired token is found.
 */
var getRefreshToken = exports.getRefreshToken = function getRefreshToken() {
  return core.getLocalToken(REFRESH_TOKEN);
};

/**
 * Returns the stored ACCESS_TOKEN from local storage.
 *
 * @returns {(string|undefined)} Returns the token string or undefined if no
 * token or an expired token is found.
 */
var getAccessToken = exports.getAccessToken = function getAccessToken() {
  return core.getLocalToken(ACCESS_TOKEN);
};

/**
 * Returns a new ACCESS_TOKEN if we have an existing REFRESH_TOKEN. If the
 * REFRESH_TOKEN is missing, the system is considered logged out, and nothing is
 * returned.
 *
 * The token will be fetched, persisted to local storage and a timer will be
 * started that will fetch a new one whenever this one is about to expire.
 *
 * @param {Function} options An object of options. Currently only supporting:
 *  - `onMissingRefreshToken` {() => void} Optional: What to execute when no
 *    valid refreshToken could be found
 *  - `onNewAccessToken` {(token: string) => void}: Will be executed when a new
 *    ACCESS_TOKEN is fetched.
 * @returns {Promise<string>} Returns a promise that will resolve to the new
 * ACCESS_TOKEN.
 */
var fetchAccessToken = exports.fetchAccessToken = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(options) {
    var refreshToken, _ref2, throwIfNoRefreshToken, onNewAccessToken, accessToken;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          refreshToken = getRefreshToken();
          _ref2 = options || {
            throwIfNoRefreshToken: false
          }, throwIfNoRefreshToken = _ref2.throwIfNoRefreshToken, onNewAccessToken = _ref2.onNewAccessToken;
          if (refreshToken) {
            _context.next = 9;
            break;
          }
          _jsTools.authConsole.groupCollapsed("failed fetching ACCESS_TOKEN (missing REFRESH_TOKEN)");
          _jsTools.authConsole.log("ACCESS_TOKEN cannot be be fetched because no REFRESH_TOKEN found. You have probably been logged out.");
          _jsTools.authConsole.groupEnd();
          if (!throwIfNoRefreshToken) {
            _context.next = 8;
            break;
          }
          throw new Error("Missing REFRESH_TOKEN");
        case 8:
          return _context.abrupt("return");
        case 9:
          _context.next = 11;
          return core.fetchToken({
            fetchMethod: fetchers.getAccessTokenWithRefreshToken,
            input: {
              refreshToken: refreshToken
            },
            tokenType: ACCESS_TOKEN,
            onFetched: onNewAccessToken,
            refreshTokenFn: fetchAccessToken.bind(_this,
            // Don't throw from renewal calls to fetchAccessToken as these throws
            // won't be caught. User will be redirected to login when they will
            // interact with the UI.
            (0, _omit["default"])(options, "throwIfNoRefreshToken")),
            _consoleGroupLabel: "ACCESS_TOKEN fetching"
          })["catch"](function (error) {
            throw new Error(error);
          });
        case 11:
          accessToken = _context.sent;
          return _context.abrupt("return", accessToken);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchAccessToken(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Refreshes the REFRESH_TOKEN if we are already logged in, ie. we have an
 * existing REFRESH_TOKEN. If no existing REFRESH_TOKEN is found, the system is
 * considered logged out and nothing is returned.
 *
 * The token will be fetched, persisted to local storage and a timer will be
 * started that will fetch a new one whenever this one is about to expire.
 *
 * @returns {Promise<string>} Returns a promise that will resolve to the new
 * REFRESH_TOKEN.
 */
var fetchRefreshedRefreshToken = exports.fetchRefreshedRefreshToken = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var refreshToken, newRefreshToken;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          refreshToken = getRefreshToken();
          if (refreshToken) {
            _context2.next = 6;
            break;
          }
          _jsTools.authConsole.groupCollapsed("failed refreshing REFRESH_TOKEN (missing REFRESH_TOKEN)");
          _jsTools.authConsole.log("REFRESH_TOKEN cannot be be refreshed because no existing REFRESH_TOKEN found. You have probably been logged out.");
          _jsTools.authConsole.groupEnd();
          return _context2.abrupt("return");
        case 6:
          _context2.next = 8;
          return core.fetchToken({
            fetchMethod: fetchers.refreshRefreshToken,
            input: {
              refreshToken: refreshToken
            },
            tokenType: REFRESH_TOKEN,
            refreshTokenFn: fetchRefreshedRefreshToken,
            _consoleGroupLabel: "REFRESH_TOKEN refreshing"
          }).then(function () {
            return _jsTools.authConsole.groupEnd();
          })["catch"](function (error) {
            throw new Error(error);
          });
        case 8:
          newRefreshToken = _context2.sent;
          return _context2.abrupt("return", newRefreshToken);
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function fetchRefreshedRefreshToken() {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Returns a REFRESH_TOKEN given an email address and a password.
 *
 * @param {Object} args An object that contains the email and password for the
 * login.
 * @returns {(Object|Promise)} It returns a Promise that will resolve to an
 * object that contains the result of executing the "getRefreshTokenEmailPass"
 * mutation.
 */
var fetchRefreshTokenEmailPass = exports.fetchRefreshTokenEmailPass = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref4) {
    var email, password, _yield$fetchers$getRe, data, error;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          email = _ref4.email, password = _ref4.password;
          _context3.next = 3;
          return fetchers.getRefreshTokenWithEmailPass({
            email: email,
            password: password
          });
        case 3:
          _yield$fetchers$getRe = _context3.sent;
          data = _yield$fetchers$getRe.data;
          error = _yield$fetchers$getRe.error;
          _jsTools.authConsole.groupCollapsed("Logging in...");
          if (!error) {
            _context3.next = 11;
            break;
          }
          _jsTools.authConsole.log("Error fetching token ".concat(error.message));
          _jsTools.authConsole.groupEnd();
          throw new Error(error.message);
        case 11:
          if (data.token) {
            persistRefreshToken(data.token);
          } else {
            _jsTools.authConsole.log("Password expired", {
              data: data
            });
          }
          _jsTools.authConsole.groupEnd();
          return _context3.abrupt("return", data);
        case 14:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function fetchRefreshTokenEmailPass(_x2) {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * Persists a REFRESH_TOKEN and optionally, a timer will be started that will
 * fetch a new one whenever this token is about to expire.
 *
 * @param {string} token The token that will be persisted as a REFRESH_TOKEN.
 * @param {boolean} noAutoRefresh Wether the auto-renewal process should be started.
 * @returns {undefined}
 */
var persistRefreshToken = exports.persistRefreshToken = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(token, noAutoRefresh) {
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          localStorage.setItem(REFRESH_TOKEN, token);
          _jsTools.authConsole.groupCollapsed("persisting REFRESH_TOKEN");
          _jsTools.authConsole.log(token);
          _jsTools.authConsole.groupEnd();
          core.refetchWhenExpires(token, fetchRefreshedRefreshToken, REFRESH_TOKEN);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function persistRefreshToken(_x3, _x4) {
    return _ref6.apply(this, arguments);
  };
}();

/**
 * Persists a ACCESS_TOKEN in local storage.
 *
 * @param {string} token The token that will be persisted as a REFRESH_TOKEN.
 * @returns {undefined}
 */
var persistAccessToken = exports.persistAccessToken = /*#__PURE__*/function () {
  var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(token) {
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          localStorage.setItem(ACCESS_TOKEN, token);
          _jsTools.authConsole.groupCollapsed("persisted ACCESS_TOKEN");
          _jsTools.authConsole.log(token);
          _jsTools.authConsole.groupEnd();
        case 4:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function persistAccessToken(_x5) {
    return _ref7.apply(this, arguments);
  };
}();

/**
 * Clears both the ACCESS_TOKEN and the REFRESH_TOKENS.
 *
 * Clearing means it will delete the token from localStorage, and it will also
 * delete its auto-renewal timer.
 *
 * @returns {undefined}
 */
var clearTokens = exports.clearTokens = function clearTokens() {
  core.clearLocalToken(ACCESS_TOKEN);
  core.clearLocalToken(REFRESH_TOKEN);
};